// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRouter from './Routes/AppRouter';
import { Provider } from 'react-redux';
import store from './Redux/Store';
import { ThemeProvider } from "@material-tailwind/react";
import { HelmetProvider } from 'react-helmet-async';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { base_url } from './utils/constante';

// ══════════════════════════════════════
// 🧪 Environnement : préprod ou local → pas de captcha ni de blocage robot
//    (pour que Selenium / Playwright puissent tester)
// ══════════════════════════════════════
const estPreprod = /preprod\.thrundrz\.fr|localhost|127\.0\.0\.1/i.test(base_url);
export const captchaActif = !estPreprod;

// ══════════════════════════════════════
// Masquer le badge reCAPTCHA (prod uniquement)
// ══════════════════════════════════════
if (captchaActif && !document.getElementById('hide-recaptcha-badge')) {
  const style = document.createElement('style');
  style.id = 'hide-recaptcha-badge';
  style.innerHTML = '.grecaptcha-badge { visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; }';
  document.head.appendChild(style);
}

// ══════════════════════════════════════
// 🛑 Blocage des navigateurs automatisés (prod uniquement)
// ══════════════════════════════════════
const ua = navigator.userAgent || '';
const estMoteurDeRecherche = /googlebot|google-inspectiontool|bingbot|duckduckbot|yandex|baiduspider|applebot|facebookexternalhit|twitterbot|linkedinbot/i.test(ua);
const estRobot =
  !estPreprod &&
  !estMoteurDeRecherche &&
  (navigator.webdriver === true ||
    /HeadlessChrome|PhantomJS|Playwright|Puppeteer/i.test(ua) ||
    window.__playwright__binding__ !== undefined ||
    window._phantom !== undefined ||
    window.callPhantom !== undefined);

const root = ReactDOM.createRoot(document.getElementById('root'));

const App = (
  <Provider store={store}>
    <ThemeProvider>
      <AppRouter />
    </ThemeProvider>
  </Provider>
);

if (estRobot) {
  root.render(
    <div style={{ minHeight: '100vh', background: '#000', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif', textAlign: 'center', padding: 16 }}>
      <div>
        <h1 style={{ fontSize: 24, marginBottom: 8 }}>Accès refusé</h1>
        <p style={{ opacity: 0.7 }}>Les navigateurs automatisés ne sont pas autorisés sur Thrundrz.</p>
      </div>
    </div>
  );
} else {
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        {captchaActif ? (
          <GoogleReCaptchaProvider
            reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            scriptProps={{ async: true, defer: true, appendTo: 'body' }}
          >
            {App}
          </GoogleReCaptchaProvider>
        ) : (
          App
        )}
      </HelmetProvider>
    </React.StrictMode>
  );
}